module.exports = __webpack_public_path__ + "static/media/Edison_Traditinoal_at_Ivory_Ridge_2.3bfae425.jpg";